<template>
  <div class="maps-search-screen">
    <div class="maps-left-frame">
      <h4 class="cnpj-section-title">PESQUISA MAPS</h4>
      <p class="cnpj-section-subtitle">
        Insira aqui as informações para buscar pelo google Maps
      </p>

      <div class="maps-search-fields">
        <!-- BUSCA PRINCIPAL -->
        <div class="input-group">
          <input
            v-model="mapsSearchTerm"
            class="maps-search-input"
            type="text"
            placeholder="Busque aqui por: Ex: Borracharia"
            @keyup.enter="searchMaps"
          />
          <button @click="searchMaps" class="search-maps-button">
            <i class="fa fa-search"></i> Buscar
          </button>
        </div>

        <!-- CEP -->
        <div class="input-group">
          <label for="cep" class="sr-only">CEP</label>
          <input
            id="cep"
            v-model="searchCep"
            type="text"
            placeholder="Busque aqui por: CEP (opcional)"
            class="cep-input"
            @keyup.enter="searchMaps"
          />
        </div>

        <!-- DISTÂNCIA -->
        <!--div class="input-group input-group-googlep--readonly">
          <label class="sr-only" for="distance">Distância</label>
          <input
            id="distance"
            :value="
              radius
                ? (radius / 1000).toLocaleString('pt-BR', {
                    maximumFractionDigits: 1,
                  }) + ' km'
                : ''
            "
            placeholder="Distancia de busca é de 5 km"
            class="distance-input search-input-google--readonly"
            type="text"
            readonly
            aria-readonly="true"
            tabindex="-1"
            @mousedown.prevent
            @click.prevent
            @keydown.prevent
          />
        </div-->
      </div>

      <!-- Container único do mapa, removendo v-if incorreto -->
      <div ref="map" class="map-container"></div>
      <!-- Caixa de informações da rota -->
      <div v-if="routeInfo" class="route-info-box">
        <p><strong>🚗 Distância:</strong> {{ routeInfo.distance }}</p>
        <p><strong>⏱️ Duração:</strong> {{ routeInfo.duration }}</p>
        <button class="clear-route-button" @click="limparRota">
          🗑️ Limpar Rota
        </button>
      </div>
    </div>

    <div class="maps-right-frame">
      <h4 class="cnpj-section-title">RESULTADOS</h4>
      <div class="table-wrapper">
        <div class="tableContainer">
          <table class="tableClient">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Endereço</th>
                <th>Telefone</th>
                <th v-if="isWhatsConnected">WHATSAPP</th>
                <th>Website</th>
              </tr>
            </thead>
            <tbody v-if="places.length && !loading">
              <tr v-for="(place, index) in paginatedResults" :key="index">
                <td class="name" :title="place.name">{{ place.name }}</td>
                <td class="addr" :title="place.address">
                  {{ place.address }}
                </td>
                <td>{{ place.phone || "Não disponível" }}</td>
                <td v-if="isWhatsConnected">
                  <span v-if="place.hasWhatsApp === 'valid'">✅</span>
                  <span v-else-if="place.hasWhatsApp === 'invalid'">❌</span>
                  <span v-else-if="place.hasWhatsApp === 'unavailable'"
                    >📴</span
                  >
                </td>
                <td>
                  <a
                    v-if="place.website !== 'Não disponível'"
                    :href="place.website"
                    target="_blank"
                  >
                    {{ place.website }}
                  </a>
                  <span v-else>Não disponível</span>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="loading" class="maps-loading-container">
            <div class="maps-loading-bar"></div>
            <p>Carregando resultados...</p>
          </div>

          <p v-if="places.length >= 50" class="search-limit-info">
            Exibindo o máximo permitido de <strong>60 registros</strong> do
            Google Maps.
          </p>

          <p v-if="!loading && !paginatedResults.length">
            Sem resultados para a pesquisa.
          </p>
          <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
        </div>
      </div>

      <!-- 🔹 Controles de Paginação e Ações -->
      <div class="pagination-container">
        <p class="record-count">Total de registros: {{ places.length }}</p>
        <div class="pagination">
          <span class="page-label">Páginas:</span>

          <button
            class="pagination-button"
            @click="previousPage"
            :disabled="currentPage === 1"
          >
            «
          </button>

          <span class="page-current">{{ currentPage }}</span>

          <button
            class="pagination-button"
            @click="nextPage"
            :disabled="currentPage === totalPages"
          >
            »
          </button>

          <span class="page-info"> {{ currentPage }} de {{ totalPages }} </span>
        </div>
      </div>

      <div class="export-container" v-if="places.length && !loading">
        <button class="small-button" @click="montarRota">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M6 20C4.895 20 4 19.105 4 18C4 16.895 4.895 16 6 16H9C10.105 16 11 15.105 11 14C11 12.895 10.105 12 9 12H8"
              stroke="#4D5163"
              stroke-width="1.8"
              stroke-linecap="round"
            />
            <path
              d="M16 4C17.105 4 18 4.895 18 6C18 7.105 17.105 8 16 8H13C11.895 8 11 8.895 11 10C11 11.105 11.895 12 13 12H14"
              stroke="#4D5163"
              stroke-width="1.8"
              stroke-linecap="round"
            />
            <circle cx="6" cy="18" r="1.5" fill="#4D5163" />
            <circle cx="16" cy="6" r="1.5" fill="#4D5163" />
          </svg>
          Montar Rota
        </button>
        <button class="small-button" @click="exportMapsCSV">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.9974 9.07464H9.07073V4.0013H15.9974V9.58797H17.3307V4.0013C17.3307 3.64768 17.1903 3.30854 16.9402 3.05849C16.6902 2.80844 16.351 2.66797 15.9974 2.66797H7.24406L2.66406 7.24797V20.0013C2.66406 20.3549 2.80454 20.6941 3.05459 20.9441C3.30464 21.1942 3.64377 21.3346 3.9974 21.3346H15.9974C16.351 21.3346 16.6902 21.1942 16.9402 20.9441C17.1903 20.6941 17.3307 20.3549 17.3307 20.0013H3.9974V9.07464ZM3.9974 7.79463L7.79073 4.0013H7.9974V8.0013H3.9974V7.79463Z"
              fill="#4D5163"
            />
            <path
              d="M18.8826 10.8986C18.7551 10.7894 18.591 10.7323 18.4232 10.7388C18.2555 10.7453 18.0963 10.8148 17.9776 10.9335C17.8588 11.0523 17.7893 11.2114 17.7828 11.3792C17.7763 11.547 17.8334 11.7111 17.9426 11.8386L20.1093 13.9986H12.0026C11.8258 13.9986 11.6562 14.0688 11.5312 14.1938C11.4062 14.3189 11.3359 14.4884 11.3359 14.6653C11.3359 14.8421 11.4062 15.0116 11.5312 15.1367C11.6562 15.2617 11.8258 15.3319 12.0026 15.3319H20.1293L17.9426 17.5186C17.8728 17.5784 17.8161 17.6519 17.7761 17.7346C17.7361 17.8173 17.7136 17.9074 17.7101 17.9992C17.7065 18.091 17.722 18.1826 17.7555 18.2681C17.789 18.3537 17.8399 18.4314 17.9048 18.4964C17.9698 18.5613 18.0475 18.6122 18.1331 18.6457C18.2186 18.6792 18.3102 18.6947 18.402 18.6911C18.4938 18.6876 18.5839 18.6651 18.6666 18.6251C18.7493 18.5851 18.8228 18.5284 18.8826 18.4586L22.6693 14.6653L18.8826 10.8986Z"
              fill="#4D5163"
            />
          </svg>
          Exportar CSV
        </button>
        <button class="small-button" @click="prepareMapsForSending">
          <svg
            width="31"
            height="31"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M25.0676 5.31937C22.447 2.69721 18.962 1.25159 15.2492 1.25C7.59605 1.25 1.36941 7.47346 1.36781 15.1234C1.36463 17.5577 2.00306 19.9506 3.21941 22.0601L1.25 29.25L8.60862 27.3204C10.6449 28.4285 12.9248 29.0096 15.2428 29.0096H15.2492C22.8992 29.0096 29.1258 22.7845 29.129 15.1346C29.1306 11.4282 27.6882 7.94313 25.0676 5.31937Z"
              stroke="#4D5163"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.6594 16.1943C12.7912 15.2296 12.1367 14.1495 11.7018 13.0538C11.6098 12.8221 11.6639 12.5508 11.825 12.3719L12.4328 11.6975C12.9307 11.1442 12.9307 10.3618 12.4958 9.87864L11.6246 8.91068C11.045 8.26675 10.1056 8.26675 9.52599 8.91068L9.04215 9.44825C8.49226 10.0592 8.26295 10.9406 8.41137 11.8146C8.77796 13.969 9.90445 16.3278 11.7218 18.347C13.5392 20.3662 15.6623 21.6178 17.6014 22.0251C18.388 22.19 19.1813 21.9352 19.7312 21.3243L20.2143 20.7875C20.7939 20.1436 20.7939 19.0998 20.2143 18.4559L19.3438 17.4887C18.909 17.0056 18.204 17.0056 17.7699 17.4887L17.0998 18.2341C16.9387 18.413 16.6946 18.4732 16.486 18.3709C15.4998 17.887 14.5277 17.1589 13.6594 16.1943Z"
              fill="#4D5163"
            />
          </svg>
          Enviar Mensagem
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* global google */
import { secureFetch } from "@/main.js";

const apiBaseUrl =
  process.env.VUE_APP_API_BASE_URL || "https://177.36.4.221:3000";

export default {
  data() {
    return {
      mapsSearchTerm: "",
      searchCep: "",
      radius: 5000,
      currentLocation: { lat: -8.0584154, lng: -34.8725719 },
      map: null,
      service: null,
      places: [],
      markers: [],
      loading: false,
      errorMessage: "",
      currentPage: 1,
      resultsPerPage: 10,
      isWhatsConnected: localStorage.getItem("qrActive") === "true",
      directionsService: null,
      directionsRenderer: null,
      routeInfo: null,
      routeSequence: [],   
      routePolylines: [], 
      searchSeq: 0,
      activeInfoWindow: null,
      activeSearchId: null,
    };
  },
  mounted() {
    this.getUserLocation();
    this.loadGoogleMapsAPI();
    window.addEventListener("storage", (e) => {
      if (e.key === "qrActive") {
        this.isWhatsConnected = e.newValue === "true";
      }
    });
  },
  computed: {
    totalPages() {
      return Math.ceil(this.places.length / this.resultsPerPage);
    },
    paginatedResults() {
      const start = (this.currentPage - 1) * this.resultsPerPage;
      const end = start + this.resultsPerPage;
      return this.places.slice(start, end);
    },
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    async getAllNearbyResults(request) {
      const currentSearch = this.activeSearchId;

      return new Promise((resolve, reject) => {
        let allResults = [];

        const handleResults = (results, status, pagination) => {
          if (this.isSearchCancelled(currentSearch)) {
            console.log("🚫 Busca antiga cancelada antes de completar.");
            return resolve([]);
          }

          console.log(
            "🧭 Status:",
            status,
            "Resultados recebidos:",
            results?.length || 0
          );

          if (status === google.maps.places.PlacesServiceStatus.OK && results) {
            allResults = [...allResults, ...results];

            if (
              pagination &&
              pagination.hasNextPage &&
              allResults.length < 60
            ) {
              setTimeout(() => {
                if (this.isSearchCancelled(currentSearch)) {
                  console.log("🚫 Paginação cancelada para busca anterior.");
                  return resolve(allResults);
                }
                pagination.nextPage();
              }, 500);
            } else {
              resolve(allResults);
            }
          } else {
            if (allResults.length > 0) resolve(allResults);
            else reject(new Error("Erro ao buscar locais com nearbySearch"));
          }
        };

        this.service.nearbySearch(request, handleResults);
      });
    },
    async loadGoogleMapsAPI() {
      if (window.google && window.google.maps) {
        console.log("✅ Google Maps já carregado.");
        this.initializeMap();
        return;
      }

      console.log("⏳ Buscando chave da API do backend...");

      try {

        // 🔥 Faz a requisição ao backend para obter a chave da API do Google Maps
        const response = await secureFetch(
          //`http://localhost:3000/get-google-api-key`,
          `${apiBaseUrl}/get-google-api-key`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Erro ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        if (!data.apiKey) {
          throw new Error("❌ Chave da API não encontrada.");
        }

        // 🔹 Removendo qualquer script antigo do Google Maps
        document
          .querySelectorAll("script[src*='maps.googleapis.com']")
          .forEach((script) => script.remove());

        // 🔹 Criando um novo script com a chave da API segura
        const script = document.createElement("script");
        //script.src = `https://maps.googleapis.com/maps/api/js?key=${data.apiKey}&libraries=places`;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${data.apiKey}&libraries=places,geometry`;
        script.async = true;
        script.defer = true;

        // 🔥 Chama `initializeMap()` apenas quando a API for carregada
        script.onload = () => {
          console.log("✅ Google Maps API carregada com sucesso!");
          this.initializeMap();
        };

        script.onerror = () => {
          console.error("❌ Erro ao carregar Google Maps API!");
        };

        document.head.appendChild(script);
        console.log("📡 Script do Google Maps adicionado ao documento.");
      } catch (error) {
        console.error("❌ Erro ao buscar chave da API:", error);
      }
    },
    async getUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            if (!isNaN(latitude) && !isNaN(longitude)) {
              this.currentLocation = { lat: latitude, lng: longitude };
              console.log(`📍 Localização obtida: ${latitude}, ${longitude}`);

              await this.getAddressFromCoords(latitude, longitude);
            } else {
              console.error(
                "⚠️ Coordenadas inválidas obtidas da geolocalização."
              );
            }
          },
          (error) => {
            console.error("Erro ao obter localização:", error);
            alert("Não foi possível obter sua localização.");
          }
        );
      } else {
        alert("Seu navegador não suporta geolocalização.");
      }
    },
    async getAddressFromCoords(lat, lng) {
      if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
        console.error("⚠️ Coordenadas inválidas para buscar endereço.");
        return;
      }
      try {

        // 🔥 Faz a requisição para o backend buscar o endereço a partir das coordenadas
        const response = await secureFetch(
          //`http://localhost:3000/get-address?lat=${lat}&lng=${lng}`,
          `${apiBaseUrl}/get-address?lat=${lat}&lng=${lng}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Erro ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        if (data.success && data.address) {
          console.log(
            `📍 Endereço encontrado para ${lat}, ${lng}:`,
            data.address
          );
          this.userCep = data.address.cep;
          this.userCidade = data.address.cidade;
          this.userEstado = data.address.estado;
        } else {
          throw new Error(
            data.message || "Erro ao processar a resposta do backend"
          );
        }
      } catch (error) {
        console.error("❌ Erro ao buscar endereço:", error);
        this.userCidade = "Localização aproximada";
        this.userEstado = "N/A";
      }
    },
    initializeMap() {
      if (!window.google || !window.google.maps) {
        console.error("❌ Google Maps API não carregada! Aguardando...");
        return;
      }

      this.$nextTick(() => {
        const mapElement = this.$refs.map;
        if (!mapElement) {
          console.warn("⚠️ Elemento do mapa não encontrado.");
          return;
        }

        // Garante uma localização inicial válida
        if (!this.currentLocation.lat || !this.currentLocation.lng) {
          console.warn("⚠️ Localização inválida. Usando padrão SP.");
          this.currentLocation = { lat: -8.0584154, lng: -34.8725719 };
        }

        console.log("🗺️ Inicializando mapa...");

        this.map = new google.maps.Map(mapElement, {
          center: this.currentLocation,
          zoom: 13,
          gestureHandling: "greedy",
        });

        this.directionsService = new google.maps.DirectionsService();
        this.directionsRenderer = new google.maps.DirectionsRenderer({
          map: this.map,
        });
        this.service = new google.maps.places.PlacesService(this.map);

        // Marcador e círculo iniciais
        this.marker = new google.maps.Marker({
          position: this.currentLocation,
          map: this.map,
          title: "Base inicial",
        });

        this.circle = new google.maps.Circle({
          strokeColor: "#007bff",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#007bff",
          fillOpacity: 0.2,
          map: this.map,
          center: this.currentLocation,
          radius: this.radius,
        });

        // Clique no mapa refaz busca no ponto clicado
        this.map.addListener("click", (event) => {
          const centerFromClick = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
          };
          console.log(
            "🗺️ Clique detectado — refazendo busca a partir do clique:",
            centerFromClick
          );
          this.searchMaps(centerFromClick);
        });

        console.log("✅ Mapa inicializado com sucesso!");
      });
    },

    // 🔹 Define a localização base (CEP > geolocalização > fallback SP)
    async getBaseLocation() {
      try {
        // 1️⃣ Se o usuário informou um CEP, prioriza ele
        if (this.searchCep && this.searchCep.trim() !== "") {
          const cleanCep = this.searchCep.replace(/\D/g, "");
          if (cleanCep.length !== 8) {
            alert("Digite um CEP válido com 8 dígitos.");
            return { lat: -23.55052, lng: -46.633308, origem: "fallback" };
          }
          const cepLocation = await this.getCoordinatesFromCep(cleanCep);
          if (cepLocation) {
            console.log("📍 Base definida pelo CEP:", cepLocation);
            return { ...cepLocation, origem: "cep" };
          }
        }

        // 2️⃣ Se geolocalização está autorizada, usa a posição do usuário
        const coords = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            (pos) => resolve(pos.coords),
            (err) => reject(err)
          );
        });

        console.log("📍 Base definida pela geolocalização:", coords);
        return {
          lat: coords.latitude,
          lng: coords.longitude,
          origem: "geolocalizacao",
        };
      } catch (error) {
        console.warn(
          "⚠️ Localização não autorizada. Usando fallback de SP.",
          error
        );
        // 3️⃣ Fallback: São Paulo
        return { lat: -23.55052, lng: -46.633308, origem: "fallback" };
      }
    },

    async searchMaps(centerOverride = null) {
      if (!this.mapsSearchTerm) {
        alert("Digite um termo de pesquisa, como 'Borracharia'");
        return;
      }

      if (!this.service && !this.map) {
        console.error("❌ Serviço de Places não inicializado.");
        return;
      }

      const searchId = Date.now();
      this.activeSearchId = searchId;

      // 🔄 Reset estado UI
      this.errorMessage = "";
      this.places = [];
      this.currentPage = 1;
      this.loading = true;

      // 🧭 Determina a base: clique > CEP > geolocalização > fallback
      let origem = "fallback";
      if (
        centerOverride &&
        !isNaN(centerOverride.lat) &&
        !isNaN(centerOverride.lng)
      ) {
        // ✅ Força conversão para número e valida
        this.currentLocation = {
          lat: Number(centerOverride.lat),
          lng: Number(centerOverride.lng),
        };
        origem = "clique";
      } else {
        const base = await this.getBaseLocation();
        this.currentLocation = {
          lat: Number(base.lat),
          lng: Number(base.lng),
        };
        origem = base.origem;
      }

      console.log("🧭 Localização base confirmada:", this.currentLocation);

      // Protege contra coordenadas inválidas
      if (
        !this.currentLocation ||
        isNaN(this.currentLocation.lat) ||
        isNaN(this.currentLocation.lng)
      ) {
        console.error(
          "⚠️ Coordenadas inválidas detectadas. Aplicando fallback SP."
        );
        this.currentLocation = { lat: -23.55052, lng: -46.633308 };
        origem = "fallback";
      }

      // 🧨 Reseta e recria o mapa centralizado na localização desejada
      this.resetMap();
      await this.$nextTick();

      this.map = new google.maps.Map(this.$refs.map, {
        center: this.currentLocation,
        zoom: 13,
        gestureHandling: "greedy",
      });

      this.service = new google.maps.places.PlacesService(this.map);
      this.directionsService = new google.maps.DirectionsService();
      this.directionsRenderer = new google.maps.DirectionsRenderer({
        map: this.map,
      });

      // ✅ Reanexa o clique a cada novo mapa
      this.map.addListener("click", (event) => {
        const centerFromClick = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };
        console.log(
          "🗺️ Clique detectado — refazendo busca a partir do clique:",
          centerFromClick
        );
        this.searchMaps(centerFromClick);
      });

      console.log(`🗺️ Mapa centralizado com base em: ${origem}`);

      // 🔵 Desenha círculo e marcador central
      this.circle = new google.maps.Circle({
        strokeColor: "#007bff",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#007bff",
        fillOpacity: 0.2,
        map: this.map,
        center: this.currentLocation,
        radius: this.radius,
      });

      this.marker = new google.maps.Marker({
        position: this.currentLocation,
        map: this.map,
        title:
          origem === "cep"
            ? `Base: CEP ${this.searchCep}`
            : origem === "geolocalizacao"
            ? "Base: Sua localização atual"
            : origem === "clique"
            ? "Base definida pelo clique"
            : "Base: São Paulo (padrão)",
      });

      try {
        const request = {
          location: this.currentLocation,
          radius: this.radius,
          keyword: this.mapsSearchTerm,
        };

        const results = await this.getAllNearbyResults(request);
        if (this.isSearchCancelled(searchId)) return;

        const enrichedPlaces = [];
        const markersToAdd = [];
        const whatsConnected = this.isWhatsConnected;

        await Promise.all(
          results.map(
            (place) =>
              new Promise((resolve) => {
                const detailsRequest = {
                  placeId: place.place_id,
                  fields: [
                    "name",
                    "formatted_address",
                    "formatted_phone_number",
                    "website",
                    "geometry",
                  ],
                };

                this.service.getDetails(
                  detailsRequest,
                  async (details, status) => {
                    if (this.isSearchCancelled(searchId)) return resolve();
                    if (status !== google.maps.places.PlacesServiceStatus.OK)
                      return resolve();

                    const placeLatLng = details.geometry.location;
                    const centerLatLng = new google.maps.LatLng(
                      this.currentLocation.lat,
                      this.currentLocation.lng
                    );
                    const distance =
                      google.maps.geometry.spherical.computeDistanceBetween(
                        centerLatLng,
                        placeLatLng
                      );
                    if (distance > this.radius) return resolve();

                    let formattedPhone = "Não disponível";
                    let hasWhatsApp = "unavailable";

                    if (details.formatted_phone_number) {
                      try {
                        formattedPhone = this.normalizeBQ(
                          details.formatted_phone_number
                        );
                        if (whatsConnected)
                          hasWhatsApp = await this.ChecaWhats(formattedPhone);
                      } catch {
                        formattedPhone = "Não disponível";
                      }
                    }

                    enrichedPlaces.push({
                      name: details.name,
                      address: details.formatted_address,
                      phone: formattedPhone,
                      hasWhatsApp,
                      website: details.website || "Não disponível",
                    });

                    markersToAdd.push(place);
                    resolve();
                  }
                );
              })
          )
        );

        if (this.isSearchCancelled(searchId)) return;

        this.places = enrichedPlaces;
        console.log(`📍 Total de lugares encontrados: ${this.places.length}`);
        this.addMarkersNew(markersToAdd);
      } catch (error) {
        console.error("❌ Erro na pesquisa do Maps:", error);
        this.errorMessage = error.message;
      } finally {
        this.loading = false;
      }
    },

    // Função para normalizar números de telefone para WhatsApp
    normalizeBQ(phoneNumber) {
      // Lista de DDDs onde NÃO se deve ter "9" para WhatsApp
      const DDDsSemNoveNoWhatsApp = [
        "81",
        "87",
        "86",
        "89",
        "84",
        "79",
        "68",
        "96",
      ];
      // Lista de DDDs onde números fixos SEMPRE têm 8 dígitos
      const DDDsSemNoveFixos = [
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
      ];

      let normalized = phoneNumber.replace(/\D/g, ""); // Remove caracteres não numéricos

      // 📌 Mantém números curtos de atendimento (4007-2109, 3003-1234) inalterados
      if (normalized.length === 7 || normalized.length === 8) {
        console.log(`📞 Número de atendimento mantido: ${phoneNumber}`);
        return phoneNumber;
      }

      // 📌 Mantém números 0800 inalterados
      if (normalized.startsWith("0800")) {
        console.log(`📞 Número 0800 mantido: ${phoneNumber}`);
        return phoneNumber;
      }

      // 📌 Se já estiver no formato correto (55 + DDD + 9 dígitos)
      if (normalized.length === 13 && normalized.startsWith("55")) {
        return normalized;
      }

      // 📌 Se já estiver no formato correto (55 + DDD + 8 dígitos fixo)
      if (normalized.length === 12 && normalized.startsWith("55")) {
        return normalized;
      }

      // 📌 Se vier sem o código do país (DDD + 8 ou 9 dígitos)
      if (normalized.length === 10 || normalized.length === 11) {
        let ddd = normalized.slice(0, 2);
        let numeroSemDDD = normalized.slice(2);

        // 📌 Se o DDD estiver na lista que NÃO deve ter "9", removemos o "9" se estiver presente
        if (DDDsSemNoveNoWhatsApp.includes(ddd)) {
          if (numeroSemDDD.length === 9 && numeroSemDDD.startsWith("9")) {
            numeroSemDDD = numeroSemDDD.slice(1); // Remove o "9"
          }
        }

        // 📌 Se for um telefone fixo, verifica a lista de DDDs que SEMPRE têm 8 dígitos fixos
        if (numeroSemDDD.length === 8 && DDDsSemNoveFixos.includes(ddd)) {
          return "55" + ddd + numeroSemDDD;
        }

        return "55" + ddd + numeroSemDDD;
      }

      // 📌 Se o número já estiver no formato 55 + DDD + 8 ou 9 dígitos
      if (normalized.length >= 12 && normalized.startsWith("55")) {
        let ddd = normalized.slice(2, 4);
        let numeroSemDDD = normalized.slice(4);

        // 📌 Se o DDD estiver na lista correta, removemos o "9" se estiver presente
        if (
          DDDsSemNoveNoWhatsApp.includes(ddd) &&
          numeroSemDDD.length === 9 &&
          numeroSemDDD.startsWith("9")
        ) {
          numeroSemDDD = numeroSemDDD.slice(1);
        }

        return "55" + ddd + numeroSemDDD;
      }

      // 📌 Retorna o número original caso não se encaixe nos padrões
      return phoneNumber;
    },

    async tracarRota(destino) {
      if (!this.currentLocation) {
        alert("Não foi possível obter sua localização atual.");
        return;
      }

      const request = {
        origin: this.currentLocation,
        destination: destino,
        travelMode: google.maps.TravelMode.DRIVING,
      };

      this.directionsService.route(request, (result, status) => {
        if (status === "OK") {
          this.directionsRenderer.setDirections(result);
          const route = result.routes[0].legs[0];
          this.routeInfo = {
            distance: route.distance.text,
            duration: route.duration.text,
          };
        } else {
          alert("Não foi possível traçar a rota.");
          this.routeInfo = null;
        }
      });
    },

    formatDuration(totalSeconds) {
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.round((totalSeconds % 3600) / 60);

      if (h > 0) {
        return `${h}h ${m}min`;
      }
      return `${m}min`;
    },

    async montarRota() {
      if (!this.currentLocation) {
        alert("Não foi possível obter o ponto de origem da rota.");
        return;
      }

      if (!this.map) {
        alert("Mapa ainda não foi inicializado.");
        return;
      }

      if (!this.markers || this.markers.length === 0) {
        alert("Nenhum ponto encontrado no mapa para montar a rota.");
        return;
      }

      // garante DirectionsService
      if (!this.directionsService) {
        this.directionsService = new google.maps.DirectionsService();
      }

      // limpa polylines anteriores
      if (this.routePolylines?.length) {
        this.routePolylines.forEach((pl) => pl.setMap(null));
      }
      this.routePolylines = [];

      const originLatLng = new google.maps.LatLng(
        this.currentLocation.lat,
        this.currentLocation.lng
      );

      // 🧭 constrói uma rota simples usando "vizinho mais próximo"
      const unvisited = [...this.markers];
      const routeMarkers = [];
      let currentPos = originLatLng;

      while (unvisited.length) {
        let bestIndex = 0;
        let bestDist = Infinity;

        unvisited.forEach((marker, idx) => {
          const d = google.maps.geometry.spherical.computeDistanceBetween(
            currentPos,
            marker.getPosition()
          );
          if (d < bestDist) {
            bestDist = d;
            bestIndex = idx;
          }
        });

        const nextMarker = unvisited.splice(bestIndex, 1)[0];
        routeMarkers.push(nextMarker);
        currentPos = nextMarker.getPosition();
      }

      // 🔢 limpa labels anteriores e marca origem com "S"
      if (this.markers?.length) {
        this.markers.forEach((m) => m.setLabel(null));
      }
      if (this.marker) {
        this.marker.setLabel("S"); // origem
      }

      const orderedStops = [];
      let totalDistance = 0;
      let totalDuration = 0;

      // pontos da rota: origem -> todos os marcadores -> volta para origem
      const points = [
        originLatLng,
        ...routeMarkers.map((m) => m.getPosition()),
        originLatLng,
      ];

      // faz uma chamada Directions por perna consecutiva
      for (let i = 0; i < points.length - 1; i++) {
        const legOrigin = points[i];
        const legDest = points[i + 1];

        try {
          const result = await new Promise((resolve, reject) => {
            this.directionsService.route(
              {
                origin: legOrigin,
                destination: legDest,
                travelMode: google.maps.TravelMode.DRIVING,
              },
              (res, status) => {
                if (status === "OK") resolve(res);
                else reject(status);
              }
            );
          });

          const route = result.routes[0];
          const leg = route.legs[0];

          if (leg.distance?.value) totalDistance += leg.distance.value;
          if (leg.duration?.value) totalDuration += leg.duration.value;

          // desenha polyline desta perna
          const polyline = new google.maps.Polyline({
            path: route.overview_path,
            strokeColor: "#1a73e8",
            strokeOpacity: 0.8,
            strokeWeight: 4,
            map: this.map,
          });

          this.routePolylines.push(polyline);
        } catch (errStatus) {
          console.error("❌ Erro ao buscar perna da rota:", errStatus);
        }
      }

      // numera os pontos na ordem da rota
      routeMarkers.forEach((marker, idx) => {
        marker.setLabel(String(idx + 1));

        orderedStops.push({
          order: idx + 1,
          name: marker.placeInfo?.name || `Ponto ${idx + 1}`,
          address: marker.placeInfo?.address || "",
        });
      });

      const distanceKm = totalDistance / 1000;

      this.routeSequence = orderedStops;
      this.routeInfo = {
        distance: `${distanceKm.toLocaleString("pt-BR", {
          maximumFractionDigits: 1,
        })} km`,
        duration: this.formatDuration(totalDuration),
        totalPoints: this.markers.length,
        usedPoints: this.markers.length, // 👈 agora usa TODOS
        partial: false,
      };

      console.log(
        `✅ Rota completa montada com ${this.markers.length} pontos. Distância: ${this.routeInfo.distance}, Tempo: ${this.routeInfo.duration}`
      );
    },

    async getCoordinatesFromCep(cep) {
      try {

        // 🔥 Faz a requisição para o backend buscar as coordenadas do CEP
        const response = await secureFetch(
          //`http://localhost:3000/get-coordinates?cep=${cep}`,
          `${apiBaseUrl}/get-coordinates?cep=${cep}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Erro ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        if (data.success && data.location) {
          console.log(
            `📍 Coordenadas encontradas para CEP ${cep}:`,
            data.location
          );
          return data.location; // Retorna { lat: xx.xxx, lng: yy.yyy }
        } else {
          throw new Error(
            data.message || "Erro ao processar a resposta do backend"
          );
        }
      } catch (error) {
        console.error("❌ Erro ao buscar o CEP:", error);
        return null;
      }
    },

    isSearchCancelled(searchId) {
      return this.activeSearchId !== searchId;
    },

    addMarkersNew(places) {
      if (!this.map) {
        console.warn("Mapa não foi inicializado.");
        return;
      }

      console.log(`📍 Adicionando ${places.length} novos marcadores...`);

      const infoWindow = (this.activeInfoWindow = new google.maps.InfoWindow());

      const newMarkers = [];

      places.forEach((place) => {
        if (this.activeSearchId === null) return;

        const marker = new google.maps.Marker({
          position: place.geometry.location,
          map: this.map,
          title: `${place.name} — clique para traçar rota`,
        });

        //this.markers.push(marker);

        newMarkers.push(marker);

        const placeDetailsRequest = {
          placeId: place.place_id,
          fields: [
            "name",
            "formatted_address",
            "formatted_phone_number",
            "website",
            "photos",
            "geometry",
          ],
        };

        this.service.getDetails(placeDetailsRequest, (details, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            const photoUrl =
              details.photos && details.photos.length > 0
                ? details.photos[0].getUrl({ maxWidth: 200, maxHeight: 150 })
                : null;

          marker.placeInfo = {
            name: details.name,
            address: details.formatted_address || "Não disponível",
          };

            const infoContent = `
          <div style="font-family: Arial, sans-serif; padding: 2px; max-width: 150px; max-height: 150px; overflow: hidden;">
            <h4 style="margin: 0; font-size: 10px;">${details.name}</h4>
            <p style="margin: 4px 0; font-size: 8px;"><strong>Endereço:</strong> ${
              details.formatted_address || "Não disponível"
            }</p>
            <p style="margin: 4px 0; font-size: 8px;"><strong>Telefone:</strong> ${
              details.formatted_phone_number || "Não disponível"
            }</p>
            ${
              photoUrl
                ? `<img src="${photoUrl}" alt="Imagem do Local" style="width: 60%; max-height: 100px; border-radius: 4px; margin-top: 4px; display: block; margin-left: auto; margin-right: auto;">`
                : ""
            }
            <p style="font-size: 9px; margin-top: 4px; color: #4285F4; font-style: italic;">
              🖱️ Clique para rota até o local.
            </p>
          </div>
        `;

            marker.addListener("mouseover", () => {
              infoWindow.setOptions({ disableAutoPan: true });
              infoWindow.setContent(infoContent);
              infoWindow.open(this.map, marker);
            });

            marker.addListener("mouseout", () => {
              infoWindow.close();
            });

            marker.addListener("click", () => {
              console.log(`🗺️ Traçando rota para: ${details.name}`);
              this.tracarRota(marker.getPosition());
            });
          }
        });
      });

      this.markers = newMarkers;

      console.log(`✅ Total de marcadores no mapa: ${this.markers.length}`);
    },

    addMarkers(places) {
      if (!this.map) {
        console.warn("Mapa não foi inicializado.");
        return;
      }

      //      this.clearMarkers();

      const infoWindow = new google.maps.InfoWindow(); // Criando uma única instância do InfoWindow

      places.forEach((place) => {
        const marker = new google.maps.Marker({
          position: place.geometry.location,
          map: this.map,
          title: `${place.name} — clique para traçar rota`,
        });

        // Adiciona o marcador ao array para controle
        this.markers.push(marker);

        // Requisição para obter mais detalhes do local
        const placeDetailsRequest = {
          placeId: place.place_id,
          fields: [
            "name",
            "formatted_address",
            "formatted_phone_number",
            "website",
            "photos",
            "geometry",
          ],
        };

        this.service.getDetails(placeDetailsRequest, (details, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            // Foto do local, se disponível
            const photoUrl =
              details.photos && details.photos.length > 0
                ? details.photos[0].getUrl({ maxWidth: 200, maxHeight: 150 })
                : null;

            // Conteúdo do InfoWindow
            const infoContent = `
            <div style="font-family: Arial, sans-serif; padding: 2px; max-width: 150px; max-height: 150px; overflow: hidden;">
              <h4 style="margin: 0; font-size: 10px;">${details.name}</h4>
              <p style="margin: 4px 0; font-size: 8px;"><strong>Endereço:</strong> ${
                details.formatted_address || "Não disponível"
              }</p>
              <p style="margin: 4px 0; font-size: 8px;"><strong>Telefone:</strong> ${
                details.formatted_phone_number || "Não disponível"
              }</p>
              ${
                photoUrl
                  ? `<img src="${photoUrl}" alt="Imagem do Local" style="width: 60%; max-height: 100px; border-radius: 4px; margin-top: 4px; display: block; margin-left: auto; margin-right: auto;">`
                  : ""
              }
              <p style="font-size: 9px; margin-top: 4px; color: #4285F4; font-style: italic;">
                🖱️ Clique para rota até o local.
              </p>
            </div>
          `;

            // Exibir informações ao passar o mouse
            marker.addListener("mouseover", () => {
              this.highlightedPlace = details.name; // Armazena o nome do local destacado
              infoWindow.setOptions({ disableAutoPan: true });
              infoWindow.setContent(infoContent);
              infoWindow.open(this.map, marker);
            });

            // Fechar ao tirar o mouse
            marker.addListener("mouseout", () => {
              this.highlightedPlace = null; // Remove o destaque ao sair do marcador
              infoWindow.close();
            });

            // Ao clicar no marcador, traça a rota
            marker.addListener("click", () => {
              console.log(`🗺️ Traçando rota para: ${details.name}`);
              this.tracarRota(marker.getPosition());
            });
          } else {
            console.warn(
              `Detalhes não encontrados para o local: ${place.name}`
            );
          }
        });
      });
      console.log(`✅ Adicionados ${this.markers.length} novos marcadores.`);
    },

    limparRota() {
      if (this.directionsRenderer) {
        this.directionsRenderer.setDirections({ routes: [] });
      }
      this.routeInfo = null;
      this.routeSequence = [];

      if (this.routePolylines?.length) {
        this.routePolylines.forEach((pl) => pl.setMap(null));
        this.routePolylines = [];
      }

      if (this.markers?.length) {
        this.markers.forEach((m) => m.setLabel(null));
      }
      if (this.marker) {
        this.marker.setLabel(null);
      }
    },

    clearMarkers() {
      if (this.markers?.length) {
        this.markers.forEach((m) => m.setMap(null));
        this.markers = [];
      }
      if (this.marker) this.marker.setMap(null);
      if (this.circle) this.circle.setMap(null);
      if (this.directionsRenderer)
        this.directionsRenderer.setDirections({ routes: [] });
    },

    resetMap() {
      console.log("🧨 Resetando o mapa completamente...");

      // Remove todos os listeners do mapa anterior (se houver)
      if (this.map) {
        google.maps.event.clearInstanceListeners(this.map);
        this.map = null;
      }

      // Limpa o conteúdo do container do mapa no DOM
      if (this.$refs.map) {
        this.$refs.map.innerHTML = "";
      }

      // Garante que marcadores, círculo, etc. sejam zerados
      this.markers = [];
      this.marker = null;
      this.circle = null;
      this.activeInfoWindow = null;

      console.log("✅ Mapa anterior destruído com sucesso!");
    },

    // 🔹 Verifica se o número tem WhatsApp chamando o backend
    async ChecaWhats(phoneNumber) {
      if (!this.isWhatsConnected) {
        console.warn("📴 WhatsApp não conectado — pulando verificação.");
        return "unavailable";
      }
      try {

        // 🔹 Formatar o número para o formato internacional correto
        const formattedNumber = `+${phoneNumber.replace(/\D/g, "")}`;

        const url = `${apiBaseUrl}/check-whatsapp?telefoneVendedor=${formattedNumber}`;

        const response = await secureFetch(
          url,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // 📴 Cliente WhatsApp não conectado
        if (response.status === 503) {
          console.warn("📴 Cliente WhatsApp não conectado.");
          return "unavailable";
        }

        if (!response.ok) {
          console.warn(
            `❌ Erro ${response.status} ao verificar WhatsApp para ${phoneNumber}`
          );
          return "invalid";
        }

        const result = await response.json();
        console.log(`🔎 API WhatsApp Response: `, result);

        console.log(
          `📞 Verificação WhatsApp para ${phoneNumber}: ${
            result.valid ? "Válido ✅" : "Inválido ❌"
          }`
        );

        return result.valid ? "valid" : "invalid";
      } catch (error) {
        console.error("❌ Erro ao verificar número no WhatsApp:", error);
        return "invalid";
      }
    },
    // 📦 Exporta resultados do Google Maps para CSV
    exportMapsCSV() {
      try {
        if (!this.places || this.places.length === 0) {
          alert("Nenhum dado para exportar.");
          return;
        }

        const headers = ["Nome", "Endereço", "Telefone", "WhatsApp", "Website"];

        // helper: normaliza acentos e escapa para CSV
        const fmt = (v) =>
          `"${String(v ?? "")
            .normalize("NFC") // evita caracteres “quebrados” (combining)
            .replace(/"/g, '""') // escapa aspas
            .replace(/;/g, ",")}"`; // evita quebrar o separador ;

        const rows = [
          headers.join(";"),
          ...this.places.map((p) => {
            const hasWhats =
              p.hasWhatsApp === "valid"
                ? "✅"
                : p.hasWhatsApp === "invalid"
                ? "❌"
                : p.hasWhatsApp === "unavailable"
                ? "📴"
                : "";

            return [
              fmt(p.name || ""),
              fmt(p.address || ""),
              fmt(p.phone || ""),
              fmt(hasWhats),
              fmt(p.website || ""),
            ].join(";");
          }),
        ];

        // BOM + CRLF ajuda o Excel a reconhecer UTF-8 e quebras de linha
        const BOM = "\uFEFF";
        const csvContent = BOM + rows.join("\r\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "pesquisa_maps.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        console.log("✅ CSV exportado com sucesso.");
      } catch (error) {
        console.error("❌ Erro ao exportar CSV:", error);
        alert("Erro ao exportar CSV. Verifique o console para detalhes.");
      }
    },
    prepareMapsForSending() {
      const contactsToSend = this.places
        .filter((place) => {
          const phone = (place.phone || "").replace(/\D/g, ""); // normaliza o número
          if (!phone || phone.startsWith("0800") || phone.length < 10) {
            console.warn(`📞 Ignorando número inválido: ${place.phone}`);
            return false;
          }
          return true;
        })
        .map((place) => ({
          name: place.name?.trim() || "Sem nome",
          number: (place.phone || "").replace(/\D/g, ""),
        }));

      if (contactsToSend.length === 0) {
        alert("Nenhum contato válido encontrado para envio!");
        return;
      }

      // 🔹 Remove duplicados com base no número
      const uniqueContacts = Array.from(
        new Map(contactsToSend.map((c) => [c.number, c])).values()
      );

      console.log(
        `📤 Emitindo ${uniqueContacts.length} contatos únicos (removidos ${
          contactsToSend.length - uniqueContacts.length
        } duplicados)`
      );

      // Emitindo contatos únicos para o componente pai
      this.$emit("prepare-send", uniqueContacts);
    },
  },
};
</script>

<style src="@/assets/styles.css"></style>
